module.exports = __webpack_public_path__ + "static/img/ad-6.4e8c61f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-6.png
// module id = G4VP
// module chunks = 0